<template>
    <DialogLayout>
        <h3 class="Modal__title">Accéder à l'enquête</h3>
        <form @submit.prevent="handleSubmit" class="FormMaterial m-t-30">
            <div class="Form__group">
                <label for="matricule">Matricule</label>
                <div class="m-b-5">
                    <input class="Form__input" type="text" id="matricule" name="matricule"
                           v-model="data.matricule">
                </div>
                <span v-if="errors.matricule">{{ errors.matricule[0] }}</span>
            </div>
            <div class="Form__group">
                <label for="code">Code sondage</label>
                <input class="Form__input m-b-5" type="text" id="code" name="code"
                       v-model="data.code">
                <span v-if="errors.code">{{ errors.code[0] }}</span>
            </div>

            <div class="text-center m-t-30">
                <button :disabled="loading" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Continuer</span>
                </button>
            </div>
        </form>
    </DialogLayout>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import Api from "../../services/Api";
    import ModalBus from "../../eventBus";
    import DialogLayout from "./Layouts/DialogLayout";
    import {getters} from "../../store";

    export default {
        props: ['isOpen'],
        components: {DialogLayout, Multiselect},
        data: function () {
            return {
                data: {
                    matricule: getters.user().profile.matricule,
                    code: null,
                },
                loading:false,
                errors: {}
            }
        },
        watch: {
            isOpen: function(newVal, oldVal) {
                this.data = {
                    matricule: null,
                    code: null,
                };
                this.loading = false;
                this.errors = {};
            }
        },
        methods: {
            async handleSubmit() {
                this.errors = {};

                try {
                    this.loading = true;
                    const {data} = await Api.post('/survey-codes', this.data);
                    window.open(data.url);
                    ModalBus.close();
                } catch (err) {
                    if (err.response.status === 422){
                        this.errors = err.response.data.errors;
                    } else {
                        ModalBus.processingError();
                    }
                }finally {
                    this.loading = false;
                }
            }
        }
    }
</script>
